<template>
<section class="content">
    <div class="box box-info">
      <a href="#"   @click.prevent="exportCSV()" >
       <img src="../../../../static/img/excel.png" style="width: 4%;float: right;"/>
      </a>
    </div>
    <div>
    <DataTable ref="po"
      :value="balanceCarryOverLists"
      :paginator="true"
      :rows="10"  :filters="filters"
      class="p-datatable-responsive-demo">
      <Column header="S.n" >
      <template #body="slotProps">
        {{slotProps.index+1}}
      </template>
      </Column>
      <Column :sortable="true"  
        header="Group"
        field="accountHeadName"
        filterMatchMode="contains"
      >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['accountHeadName']" />
        </template>
      </Column>
      <Column :sortable="true"  
        header="Sub Group"
        field="accountSubHeadName"
        filterMatchMode="contains"
      >
       <template #filter>
         <InputText type="text" class="p-column-filter" v-model="filters['accountSubHeadName']" />
       </template>
      </Column>
      <Column :sortable="true"   header="Name" field="name" filterMatchMode="contains" >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['name']" />
      </template>
      </Column>
      <Column :sortable="true"
        header="Balance"
        field="closingBalance"
        filterMatchMode="contains"
        bodyStyle="text-align: right"
      >
        <template #body="slotProps">
          {{slotProps.data.openingBalance < 0? slotProps.data.openingBalance * (-1):slotProps.data.openingBalance}}
        </template>
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['openingBalance']" />
      </template>
      </Column>

      <Column :sortable="true"
        header="Dr-Cr"
        field="openingDrCr"
        filterMatchMode="contains"
      >
      <template #filter>
        <InputText type="text" class="p-column-filter" v-model="filters['openingDrCr']" />
      </template>
      </Column>
    </DataTable>
  </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'balanceBroughtDownSettlementList',
  data () {
    return {
      columnList: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    InputText,
    Button
  },
  computed: {
    balanceCarryOverLists() {
      return this.$store.state.finalYearSettlement.balanceCarryOverLists
    }
  },
  mounted() {
    this.balanceCarryOverList()
    this.columnNames()
  },
  methods: {
    async balanceCarryOverList() {
      try {
        await this.$store.dispatch('loadBalanceCarryOverList')
      } catch (e) {}
    },
    exportCSV() {
      let data = {
        columnList: this.columnList
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/Account List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
        method: 'get',
        headers: { 'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'accountList.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// balanceCarryOverReport.vue?3fc8d972